import EnterpriseObjectMemberMetadata from "../../EnterpriseObjectMemberMetadata";
import EnterpriseObjectMetadata from "../../EnterpriseObjectMetadata";

// The kinds of change order, for the type picker.
class ChangeOrderTypeEnterpriseObjectMetadata extends EnterpriseObjectMetadata {

    constructor() {
        super();

        this.name = "ChangeOrderType";
        this.primaryEnterpriseComponent = "ChangeOrderType";

        const eom: EnterpriseObjectMemberMetadata = new EnterpriseObjectMemberMetadata();
        eom.name = "ChangeOrderType";
        eom.enterpriseComponent = "ChangeOrderType";
        eom.relationship = undefined;
        this.enterpriseComponentMembers.set(eom.name, eom);
    }
}

export default ChangeOrderTypeEnterpriseObjectMetadata;
